import { NextPage } from "next";
import Script from "next/script";
import { SEO } from "@/interfaces/seo";

import { Article, ArticleProps } from "@/components/common/article/Article";
import { PageProps } from "@/pages/_app";

import { Layout } from "@/components/layout/Layout";
import { SEOWithoutTemplate } from "@/interfaces/seoWithoutTemplate";
import { routes } from "@/routes/routes";
import { injectPurifiedHTML } from "@/utils/injectPurifiedHTML";
import { removeEmptyRel } from "@/utils/removeEmptyRel";
import styles from "./Cgv.module.scss";

export type CGVPageContentApiResponse = {
  data: CGVData;
};

type CGVData = {
  id: number;
  attributes: CgvPageContent;
};

export type CgvPageContent = {
  title: string;
  createdAt: Date;
  updatedAt: Date;
  publishedAt: Date;
  locale: string;
  description: string;
  slug: string;
  articles: ArticleProps[];
  seo: SEO;
  seoWithoutTemplate: SEOWithoutTemplate;
};

type CvgPageProps = PageProps & {
  cgvPageContent: CgvPageContent;
};

export const Cgv: NextPage<CvgPageProps> = ({
  layout,
  cgvPageContent,
}: CvgPageProps) => (
  <>
    <Layout
      layout={layout}
      pageMeta={cgvPageContent.seo}
      title={cgvPageContent.seoWithoutTemplate.title}
      description={cgvPageContent.seoWithoutTemplate.description}
      defaultCanonicalRoute={routes.cgv}
    >
      <Script
        id="insider-cgv-page"
        strategy="beforeInteractive"
        dangerouslySetInnerHTML={{
          __html: `
          window.insider_object = window.insider_object || {};
          window.insider_object.page = {
              "type": "Content"
          }
          `,
        }}
      />
      <div className={styles.main}>
        <div className={styles.container}>
          <h1 className={styles.title}>{cgvPageContent.title}</h1>
          <div
            className={styles.description}
            dangerouslySetInnerHTML={injectPurifiedHTML(
              removeEmptyRel(cgvPageContent.description)
            )}
          />
          {cgvPageContent.articles.map((article, index) => (
            <Article key={index} {...article} />
          ))}
        </div>
      </div>
    </Layout>
  </>
);
